import React, { useState } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "./admission.css";

const getNextFormID = () => {
  let current = parseInt(localStorage.getItem("bsFormCounter") || "1");
  localStorage.setItem("bsFormCounter", (current + 1).toString());
  return current;
};

const BSAdmission = () => {
  const [formData, setFormData] = useState({
    studentName: "",
    studentCnic: "",   // ✅ student CNIC
    fatherName: "",
    dob: "",
    phone: "",
    income: "",
    maritalStatus: "",
    place: "",
    permanentAddress: "",
    presentAddress: "",
    gender: "",
    lastInstitute: "",
    cnic: "",          // Father/Guardian CNIC
    interRollNo: "",
    interSubject: "",
    interObtainedMarks: "",
    interTotalMarks: "",
    percentage: "",
    programType: "",   // BS or ADP
    programName: "",   // Botany, CS, Psychology...
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedForm = { ...formData, [name]: value };

    // Auto-calc percentage
    if (name === "interObtainedMarks" || name === "interTotalMarks") {
      const obtained =
        name === "interObtainedMarks"
          ? parseFloat(value)
          : parseFloat(updatedForm.interObtainedMarks);
      const total =
        name === "interTotalMarks"
          ? parseFloat(value)
          : parseFloat(updatedForm.interTotalMarks);

      if (!isNaN(obtained) && !isNaN(total) && total > 0) {
        updatedForm.percentage = ((obtained / total) * 100).toFixed(2);
      } else {
        updatedForm.percentage = "";
      }
    }

    setFormData(updatedForm);
  };

  const generatePDF = (data, formNo) => {
  const doc = new jsPDF();
  doc.setFontSize(16);
  doc.text(`BS/ADP Admission Form No: ${formNo}`, 20, 20);

  const rows = [
    ["Name of Student", data.studentName],
    ["Student CNIC", data.studentCnic],
    ["Father's Name", data.fatherName],
    ["Date of Birth", data.dob],
    ["CNIC of Father/Guardian", data.cnic],
    ["Phone Number", data.phone],
    ["Monthly Income", data.income],
    ["Marital Status", data.maritalStatus],
    ["Place of Domicile", data.place],
    ["Permanent Address", data.permanentAddress],
    ["Present Address", data.presentAddress],
    ["Gender", data.gender],
    ["Last Institute Attended", data.lastInstitute],
    ["Intermediate Roll Number", data.interRollNo],
    ["Intermediate Subject", data.interSubject],
    ["Obtained Marks", data.interObtainedMarks],
    ["Total Marks", data.interTotalMarks],
    ["Percentage", data.percentage],
    ["Program Type", data.programType],
    ["Program Name", data.programName],
  ];

  autoTable(doc, {
    startY: 30,
    head: [["", ""]],
    body: rows,
    theme: "grid",
    styles: { fontSize: 11 },
  });

  doc.save(`AdmissionForm_${formNo}.pdf`);
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    const { programType, percentage, interSubject } = formData;
    const parsedPercentage = parseFloat(percentage);

    // Eligibility
    if (programType === "BS") {
      if (interSubject === "Arts") {
        alert("Students with Arts subjects are not eligible for BS programs.");
        return;
      }
      if (parsedPercentage < 50) {
        alert("Minimum 50% required for BS Programs.");
        return;
      }
    } else if (programType === "ADP") {
      if (parsedPercentage < 40) {
        alert("Minimum 40% required for ADP Programs.");
        return;
      }
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(
        "https://admisson.gdcs.edu.pk/admission-api/bachelor.php",
        {
          //"http://localhost/new-educational-website/admission-api/bachelor.php",
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const text = await response.text();
      let result;
      try {
        result = JSON.parse(text);
      } catch (e) {
        console.error("Invalid JSON response:", text);
        // alert("Server returned invalid response: " + text);
        alert(
          `You’ve already applied for ${formData.programType} – ${formData.programName}. Duplicate submission blocked.`
        );

        return;
      }

      console.log("Backend response:", result);

      if (response.ok && result.message) {
        alert(result.message);

      // Use the unique ID from backend (DB)
        generatePDF(formData, result.formNo);
    }
       else {
        alert("Failed: " + (result.error || "Unknown error"));
      }
    } catch (error) {
      console.error("Submission error:", error);
      alert("Error submitting form: " + error.message);
    }
    finally {
    setIsSubmitting(false);

    }

  };

  return (
    <div className="form-container">
      <div className="form-box">
        <h2>BS / ADP Admission Form</h2>
        <form onSubmit={handleSubmit} className="form-grid">
          <input
            type="text"
            name="studentName"
            placeholder="Name of Student"
            required
            onChange={handleChange}
          />
          <input
            type="number"
            name="studentCnic"
            placeholder="CNiC must be 13 digit without dashes"
            pattern="\d{13}"
            required
            onChange={handleChange}
          />
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span>Date of Birth:</span>
            <input
              type="date"
              name="dob"
              id="dob"
              required
              onChange={handleChange}
            />
          </div>

          <input
            type="text"
            name="fatherName"
            placeholder="Father's/Guardian Name"
            required
            onChange={handleChange}
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            required
            onChange={handleChange}
          />
          <input
            type="number"
            name="income"
            placeholder="Monthly Income"
            required
            onChange={handleChange}
          />
          <select name="maritalStatus" required onChange={handleChange}>
            <option value="">Marital Status</option>
            <option value="Single">Single</option>
            <option value="Married">Married</option>
          </select>
          <input
            type="text"
            name="place"
            placeholder="Place of Domicile"
            required
            onChange={handleChange}
          />
          <input
            type="text"
            name="permanentAddress"
            placeholder="Permanent Address"
            required
            onChange={handleChange}
          />
          <input
            type="text"
            name="presentAddress"
            placeholder="Present Address"
            required
            onChange={handleChange}
          />
          <input
            type="text"
            name="lastInstitute"
            placeholder="Last Institute Attended"
            required
            onChange={handleChange}
          />
          <input
            type="number"
            name="cnic"
            placeholder="CNIC of Father/Guardian"
            required
            onChange={handleChange}
          />

          {/* Intermediate Info */}
          <input
            type="number"
            name="interRollNo"
            placeholder="Intermediate Roll Number"
            required
            onChange={handleChange}
          />
          <select name="interSubject" required onChange={handleChange}>
            <option value="">Intermediate Subject</option>
            <option value="Pre-Medical">Pre-Medical</option>
            <option value="Pre-Engineering">Pre-Engineering</option>
            <option value="DAE">DAE</option>
            <option value="General Science with Math">
              General Science with Math
            </option>
            <option value="Arts">Arts</option>
          </select>
          <input
            type="number"
            name="interObtainedMarks"
            placeholder="Obtained Marks"
            required
            onChange={handleChange}
          />
          <input
            type="number"
            name="interTotalMarks"
            placeholder="Total Marks"
            required
            onChange={handleChange}
          />
          <input
            type="number"
            name="percentage"
            placeholder="Intermediate Percentage"
            value={formData.percentage}
            readOnly
          />

          {/* Program Selection */}
          {formData.interSubject === "Arts" ? (
            <select name="programType" required onChange={handleChange}>
              <option value="">Select Program Type</option>
              <option value="ADP">ADP</option>
            </select>
          ) : (
            <select name="programType" required onChange={handleChange}>
              <option value="">Select Program Type</option>
              <option value="BS">BS</option>
              <option value="ADP">ADP</option>
            </select>
          )}

          {formData.programType === "BS" && (
            <select name="programName" required onChange={handleChange}>
              <option value="">Select BS Program</option>
              <option value="CS">Computer Science</option>
              <option value="Botany">Botany</option>
              {/* <option value="Zoology">Zoology</option>
              <option value="Physics">Physics</option> */}
            </select>
          )}

          {formData.programType === "ADP" && (
            <select name="programName" required onChange={handleChange}>
              <option value="">Select ADP Program</option>
              <option value="Psychology">Psychology</option>
              <option value="Political Science">Political Science</option>
              {/* <option value="Commerce">Commerce</option>
              <option value="Arts">Arts</option> */}
            </select>
          )}

          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit Form"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default BSAdmission;
